// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3RWNL","fileBtn":"File_fileBtn__3n8pQ","closeBtn":"File_closeBtn__3Knw7","fileSelected":"File_fileSelected__28nLR","disabled":"File_disabled__CsqoV"};